import "./App.css";
import { Routers } from "./router";
import { CustomThemeProvider, useTheme } from "./ThemeContext";
import { createTheme, Typography, ThemeProvider } from "@mui/material";
import { Amplify } from "aws-amplify";

import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";

import awsExports from "./aws-exports";
import { ToastContainer } from "react-toastify";
Amplify.configure(awsExports);

// TODO: IMPORTAR DARK MODE E LIGHT MODE
const ThemeToggleButton = () => {
  const { theme, toggleTheme } = useTheme();
  return (
    <button onClick={toggleTheme} className="theme-button">
      {theme === "light" ? "🌙 Dark Mode" : "☀️ Light Mode"}
    </button>
  );
};

const theme = createTheme({
  typography: {
    fontFamily: '"Open Sans", sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Authenticator.Provider>
        <div className="App">
          {/* <ThemeToggleButton /> */}
          <Routers />
          <ToastContainer autoClose={5000} />
        </div>
      </Authenticator.Provider>
    </ThemeProvider>
  );
}

export default App;
